import * as Actions from "./constants";

export function setSuccess(payload) {
  return {
    type: Actions.SET_SUCCESS_COBRO_EXPRESS,
    payload,
  };
}

export function clearSuccess() {
  return {
    type: Actions.CLEAR_SUCCESS,
  };
}

export * from "./expressCharge.action";
